module.exports = __webpack_public_path__ + "static/media/VectorFingerprint.e58bef63.svg";